import { Box, Grid, GridItem, HStack, VStack } from '@chakra-ui/react';
import React from 'react';

import { colors } from 'themes/foundations/colors';

import { Typography } from 'components/atoms';

import {
  DisableIcon,
  JodFbAmazingAttitude,
  JodFbFastLearner,
  JodFbGoodWorkEthic,
  JodFbHighlyDependable,
  JodFbProficientSkills,
} from 'assets/icons';
import { useCurrentUser } from 'hooks/components/auth';
import { Role } from 'models/user';
import { JodBadge } from 'models/jod_badge';

export type EmployeeBadgesProps = {
  badges?: JodBadge[];
};

export const EmployeeBadges: React.FC<EmployeeBadgesProps> = ({ badges }) => {

  const currentUser = useCurrentUser();
  const isSuperAdmin = currentUser?.user_type === Role.SuperAdmin;

  // array badges
  const data_badges = [
    {
      id: 1,
      name: 'amazing_attitude',
      label: 'Amazing Attitude',
      status: 0,
    },
    {
      id: 2,
      name: 'good_work_ethic',
      label: 'Good Work Ethic',
      status: 1,
    },
    {
      id: 3,
      name: 'fast_learner',
      label: 'Fast Learner',
      status: 0,
    },
    {
      id: 4,
      name: 'team_player',
      label: 'Team Player',
      status: 1,
    },
    {
      id: 5,
      name: 'highly_dependable',
      label: 'Highly Dependable',
      status: 0,
    },
    {
      id: 6,
      name: 'negative_applicant',
      label: 'Negative Applicant',
      status: 0,
    },
  ];

  const badgeIcons: { [key: string]: React.FunctionComponent<React.SVGProps<SVGSVGElement>> } = {
    amazing_attitude: JodFbAmazingAttitude,
    good_work_ethic: JodFbGoodWorkEthic,
    fast_learner: JodFbFastLearner,
    team_player: JodFbProficientSkills,
    highly_dependable: JodFbHighlyDependable,
    negative_applicant: DisableIcon
  };

  return (
    <>
      <Grid templateColumns="" gap={6}>
        <HStack spacing={3}>
          {data_badges.map((badge) => {
            if (badge.name==="negative_applicant" && !isSuperAdmin) return null;
            const BadgeIconComponent = badgeIcons[badge.name];
            const status = badges?.find((b) => b.name === badge.name) ? true : false;
            return (
              <GridItem key={badge.id}>
                <Box
                  w="100px"
                  h="auto"
                  textAlign="center"
                  paddingX="4"
                  sx={{
                    opacity: status ? 1 : 0.5,
                    bg: 'transparent',
                    _active: {
                      bg: 'transparent',
                    },
                    _focus: {
                      boxShadow: 'none',
                    },
                  }}
                >
                  <VStack spacing={2}>
                    <BadgeIconComponent
                      width={30}
                      height={30}
                      colorProfile={status ? colors.graphOpen : colors.vulcan[500]}
                    />
                    <Typography.Text
                      color={status ? colors.graphOpen : colors.vulcan[500]}
                      fontSize="sm"
                    >
                      {badge.label}
                    </Typography.Text>
                  </VStack>
                </Box>
              </GridItem>
            );
          })}
        </HStack>
      </Grid>
    </>
  );
};
